import * as S from './style';
import ModalBase from '../ModalBase';
import { ModalBaseProps } from '../types/modal';

export interface ModalPdfProps extends ModalBaseProps {
  url: string;
}

export default function ModalPdf({ url, isOpen, handleClose }: ModalPdfProps) {
  return (
    <ModalBase isOpen={isOpen} handleClose={handleClose}>
      <S.Wrapper>
        <S.Iframe src={url}></S.Iframe>
      </S.Wrapper>
    </ModalBase>
  );
}
